module.exports = __webpack_public_path__ + "img/123.801f9898.png";